<template>
  <div class="UPSMonitoring-wrap">
    <el-row :gutter="20" class="box">
      <el-col :span="4" class="box-left">
        <el-row class="left">
          <div class="left-top">
            黄浦区政府凯通楼
          </div>
          <div class="left-content">
            <p v-for="(item,index) in upsData" :key="index" @click="changeColor(item,index)" :value="item.value" class="left-content-box" :class="{'spanColor':index==isActive }">{{item.value}}</p>
          </div>
        </el-row>
      </el-col>
      <el-col :span="20" class="box-right">
        <el-row class="main">
          <el-row class="right-top">
            <el-col :xs="12" :sm="12" :md="6" :lg="6" class="right-top-box">
              <div class="right-top-box-top">
                <div class="right-top-title">
                  <span class="right-top-big">191.2</span><span class="right-top-small">V</span>
                </div>
                <span class="right-top-centent"> 电池电压</span>
              </div>
              <div class="right-top-box-line">
                <nk-upsLine :lineData="lineData"></nk-upsLine>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" class="right-top-box">
              <div class="right-top-box-top">
                <div class="right-top-title">
                  <span class="right-top-big">191.2</span><span class="right-top-small">A</span>
                </div>
                <span class="right-top-centent"> 电池电流</span>
              </div>
              <div class="right-top-box-line">
                <nk-upsLine :lineData="lineDataOne"></nk-upsLine>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" class="right-top-box">
              <div class="right-top-box-top">
                <div class="right-top-title">
                  <span class="right-top-big">50</span><span class="right-top-small">Hz</span>
                </div>
                <span class="right-top-centent"> 频率</span>
              </div>
              <div class="right-top-box-line">
                <nk-upsLine :lineData="lineDataTwo"></nk-upsLine>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" class="right-top-box">
              <div class="right-top-box-top">
                <div class="right-top-title">
                  <span class="right-top-big">9.3</span><span class="right-top-small">%</span>
                </div>
                <span class="right-top-centent"> 负载率</span>
              </div>
              <div class="right-top-box-line">
                <nk-upsLine :lineData="lineDataThree"></nk-upsLine>
              </div>
            </el-col>
          </el-row>
          <el-row class="right-content">
            <el-row class="right-content-top">
              <div class="right-content-top-title">{{ups}}</div>
              <div class="right-content-top-usp">最新数据时间:<span class="usp-small">{{nowTime}}</span></div>
            </el-row>
            <el-row class="right-content-bottom">
              <div class="jc-left">
                <div class="the-input">
                  <div class="horn horn1"></div>
                  <div class="horn horn2"></div>
                  <div class="horn horn3"></div>
                  <div class="horn horn4"></div>
                  <div class="title">
                    <div class="left"></div>
                    输入监测
                    <div class="right"></div>
                  </div>
                  <div class="conten">
                    <div class="conten-box">
                      <div class="ziti">市电电压Uab </div>
                      <div class="value">{{Uab}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电压Uba</div>
                      <div class="value">{{Uba}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电压Uca</div>
                      <div class="value">{{Uca}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电流la</div>
                      <div class="value">{{la}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电流lb</div>
                      <div class="value">{{lb}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电流lc</div>
                      <div class="value">{{lc}}A</div>
                    </div>
                  </div>
                </div>
                <div class="the-input">
                  <div class="horn horn1"></div>
                  <div class="horn horn2"></div>
                  <div class="horn horn3"></div>
                  <div class="horn horn4"></div>
                  <div class="title">
                    <div class="left"></div>
                    旁路监测
                    <div class="right"></div>
                  </div>
                  <div class="conten">
                    <div class="conten-box">
                      <div class="ziti">旁路电压Ua</div>
                      <div class="value">{{Ua}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">旁路电压Ub</div>
                      <div class="value">{{Ub}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">旁路电压Uc</div>
                      <div class="value">{{Uc}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">旁路电流la</div>
                      <div class="value">{{pla}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">旁路电流lb</div>
                      <div class="value">{{plb}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">旁路电流lc</div>
                      <div class="value">{{plc}}A</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="img">
                <img :src="bigIg">
              </div>
              <div class="jc-right">
                <div class="the-input">
                  <div class="horn horn1"></div>
                  <div class="horn horn2"></div>
                  <div class="horn horn3"></div>
                  <div class="horn horn4"></div>
                  <div class="title">
                    <div class="left"></div>
                    输入监测
                    <div class="right"></div>
                  </div>
                  <div class="conten">
                    <div class="conten-box">
                      <div class="ziti">市电电压Uab </div>
                      <div class="value">{{iab}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电压Uba</div>
                      <div class="value">{{iba}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电压Uca</div>
                      <div class="value">{{ica}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电流la</div>
                      <div class="value">{{ila}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电流lb</div>
                      <div class="value">{{ilb}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">市电电流lc</div>
                      <div class="value">{{ilc}}A</div>
                    </div>
                  </div>
                </div>
                <div class="the-input">
                  <div class="horn horn1"></div>
                  <div class="horn horn2"></div>
                  <div class="horn horn3"></div>
                  <div class="horn horn4"></div>
                  <div class="title">
                    <div class="left"></div>
                    电池监测
                    <div class="right"></div>
                  </div>
                  <div class="conten">
                    <div class="conten-box">
                      <div class="ziti">电池电压</div>
                      <div class="value">{{voltage}}V</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">电池电流</div>
                      <div class="value">{{ele}}A</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">电池容量</div>
                      <div class="value">{{capacity}}Vh</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">电池温度</div>
                      <div class="value">{{temperature}}℃</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">电池剩余时间</div>
                      <div class="value">{{syTime}}Min</div>
                    </div>
                  </div>
                </div>
                <div class="the-input">
                  <div class="horn horn1"></div>
                  <div class="horn horn2"></div>
                  <div class="horn horn3"></div>
                  <div class="horn horn4"></div>
                  <div class="title">
                    <div class="left"></div>
                    工作状态
                    <div class="right"></div>
                  </div>
                  <div class="conten">
                    <div class="conten-box">
                      <div class="ziti">警告</div>
                      <div class="value">{{alarm}}</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">功率因数</div>
                      <div class="value">{{power}}</div>
                    </div>
                    <div class="conten-box">
                      <div class="ziti">频率</div>
                      <div class="value">{{frequency}}Hz</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-row>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@common/api/index.js'
import NkUpsLine from "@/components/page/nkUpsLine/NkUpsLine";
import dateTool from '@/utils/dateTool'
import bigIg from '@/assets/images/logo_lt.png'
export default {
  name: "UPSMonitoring",
  // 引用组件
  components: { NkUpsLine },
  data () {
    return {
      upsData: [
        { id: 0, value: "1#UPS" },
        { id: 1, value: "2#UPS" },
        { id: 2, value: "3#UPS" },
        { id: 3, value: "4#UPS" },
        { id: 4, value: "5#UPS" },
        { id: 5, value: "6#UPS" }
      ],
      isActive: false,
      lineData: {
        x: ["12-13 1997", "07-09 1998", "03-14 1999", "12-13 1997", "11-17 1999", "07-22 2000"],
        // x:["12-13","07-09","03-14","12-13","11-17","07-22"],
        name: "张三",
        data: [2, 4, 6, 8, 10, 12]
      },
      lineDataOne: {
        x: ["12-13 1997", "07-09 1998", "03-14 1999", "12-13 1997", "11-17 1999", "07-22 2000"],
        name: "张三",
        data: [2, 4, 6, 8, 10, 12]
      },
      lineDataTwo: {
        x: ["12-13 1997", "07-09 1998", "03-14 1999", "12-13 1997", "11-17 1999", "07-22 2000"],
        name: "张三",
        data: [2, 4, 6, 8, 10, 12]
      },
      lineDataThree: {
        x: ["12-13 1997", "07-09 1998", "03-14 1999", "12-13 1997", "11-17 1999", "07-22 2000"],
        name: "张三",
        data: [2, 4, 6, 8, 10, 12]
      },
      ups: '1#UPS',
      nowTime: "2010-10-09 10:00:00",
      //左边输出监测模块
      Uab: '1',
      Uba: '2',
      Uca: '3',
      la: '4',
      lb: '5',
      lc: '6',
      //左边输出监测模块
      CEle: '7',
      normal: '8',
      //左边旁路监测
      Ua: "21",
      Ub: "22",
      Uc: "24",
      pla: "25",
      plb: "26",
      plc: "27",
      //左边旁路监测
      //右边旁路监测
      iab: '1',
      iba: '2',
      ica: '3',
      ila: '4',
      ilb: '5',
      ilc: '6',
      //右边旁路监测
      //右边电池监测
      voltage: '21',
      ele: "34",
      capacity: "54",
      temperature: "44",
      syTime: "22",
      //右边电池监测
      //右边工作状态
      alarm: "21",
      power: "33",
      frequency: "23",
      //右边工作状态
      remainingEle: "9",
      remainingTime: '10',
      bigIg: bigIg
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  create () { },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    this.nowTime = dateTool.format(new Date(), "yyyy-MM-dd hh:mm:ss")
  },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    changeColor (item, index) {
      let vm = this
      vm.isActive = index
      vm.ups = item.value
    }
  },
};
</script>
<style lang="scss" scoped>
.UPSMonitoring-wrap {
  height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background: rgba(15, 5, 63);
  .box {
    width: 100%;
    height: 100%;
    background: #0f053f;
    .box-left {
      height: 100%;
      .left {
        width: 80%;
        height: 100%;
        display: flex;
        flex-flow: column;
        padding-top: 20px;
        box-sizing: border-box;
        margin: 0 auto;
        .left-top {
          font-size: 19px;
          line-height: 40px;
          background: rgba(71, 99, 121);
          font-weight: 600;
          margin-left: 14px;
          margin-right: 14px;
          margin-bottom: 8px;
          color: #fff;
        }
        .left-content {
          .left-content-box {
            color: #27f1f2;
            font-size: 18px;
            text-align: left;
            padding-left: 10px;
            line-height: 40px;
            cursor: pointer;
            margin: 0px;
          }
          .spanColor {
            background: rgba(132, 156, 44);
            color: #fff;
          }
        }
      }
    }
    .box-right {
      height: 100%;
      .main {
        height: 100%;
        margin-top: 5px;
        display: flex;
        flex-flow: column;
        .right-top {
          height: 110px;
          .right-top-box {
            height: 110px;
            display: flex;
            flex-flow: row;
            .right-top-box-top {
              display: flex;
              flex: 2;
              flex-flow: column;
              justify-content: center;
              .right-top-title {
                margin-bottom: 10px;
                .right-top-big {
                  font-size: 26px;
                  color: rgba(0, 255, 0);
                  font-weight: 600;
                  margin-right: 5px;
                }
                .right-top-small {
                  color: rgba(0, 255, 0);
                  font-size: 18px;
                }
              }
              .right-top-centent {
                color: rgba(87, 144, 251);
              }
            }
            .right-top-box-line {
              display: flex;
              flex: 3;
            }
          }
        }
        .right-content {
          margin-top: 65px;
          display: flex;
          flex: 1;
          flex-flow: column;
          .right-content-top {
            margin-bottom: 14px;
            .right-content-top-title {
              line-height: 30px;
              font-size: 17px;
              font-weight: 600;
            }
            .right-content-top-usp {
              color: rgba(74, 119, 219);
              .usp-small {
                font-size: 12px;
                margin-left: 6px;
              }
            }
          }
          .right-content-bottom {
            display: flex;
            flex: 1;
            flex-flow: row;
            .jc-left {
              display: flex;
              flex: 1;
              flex-flow: column;
              align-items: center;
              .the-input {
                position: relative;
                width: 190px;
                border: 1px solid #2edadf;
                margin-bottom: 42px;
                display: flex;
                // align-items: center;
                flex-flow: column;
                padding-bottom: 20px;
                .horn {
                  position: absolute;
                  width: 20px;
                  height: 20px;
                  z-index: 99;
                }
                .horn1 {
                  border-top: 2px solid;
                  border-left: 2px solid;
                  border-color: rgba(97, 244, 254);
                  top: 0px;
                  left: 0px;
                }
                .horn2 {
                  border-top: 2px solid;
                  border-right: 2px solid;
                  border-color: rgba(97, 244, 254);
                  top: 0px;
                  right: 0px;
                }
                .horn3 {
                  border-bottom: 2px solid;
                  border-left: 2px solid;
                  border-color: rgba(97, 244, 254);
                  bottom: 0px;
                  left: 0px;
                }
                .horn4 {
                  border-bottom: 2px solid;
                  border-right: 2px solid;
                  border-color: rgba(97, 244, 254);
                  bottom: 0px;
                  right: 0px;
                }
                .title {
                  border: 1px solid #2edadf;
                  margin: 0 30px;
                }
                .conten {
                  display: flex;
                  flex: 1;
                  flex-flow: column;
                  .conten-box {
                    display: flex;
                    flex: 1;
                    flex-flow: row;
                    margin-top: 5px;
                    .ziti {
                      flex: 2;
                      text-align: right;
                      color: rgba(87, 144, 251);
                    }
                    .value {
                      flex: 1;
                      text-align: left;
                      margin-left: 15px;
                      color: rgba(2, 239, 5);
                    }
                  }
                }
              }
            }
            .img {
              display: flex;
              flex: 1;
              flex-flow: column;
              align-items: center;
            }
            .jc-right {
              display: flex;
              flex: 1;
              flex-flow: column;
              align-items: center;
              .the-input {
                position: relative;
                width: 190px;
                border: 1px solid #2edadf;
                margin-bottom: 42px;
                display: flex;
                // align-items: center;
                flex-flow: column;
                padding-bottom: 20px;
                .horn {
                  position: absolute;
                  width: 20px;
                  height: 20px;
                  z-index: 99;
                }
                .horn1 {
                  border-top: 2px solid;
                  border-left: 2px solid;
                  border-color: rgba(97, 244, 254);
                  top: 0px;
                  left: 0px;
                }
                .horn2 {
                  border-top: 2px solid;
                  border-right: 2px solid;
                  border-color: rgba(97, 244, 254);
                  top: 0px;
                  right: 0px;
                }
                .horn3 {
                  border-bottom: 2px solid;
                  border-left: 2px solid;
                  border-color: rgba(97, 244, 254);
                  bottom: 0px;
                  left: 0px;
                }
                .horn4 {
                  border-bottom: 2px solid;
                  border-right: 2px solid;
                  border-color: rgba(97, 244, 254);
                  bottom: 0px;
                  right: 0px;
                }
                .title {
                  border: 1px solid #2edadf;
                  margin: 0 30px;
                }
                .conten {
                  display: flex;
                  flex: 1;
                  flex-flow: column;
                  .conten-box {
                    display: flex;
                    flex: 1;
                    flex-flow: row;
                    margin-top: 5px;
                    .ziti {
                      flex: 2;
                      text-align: right;
                      color: rgba(87, 144, 251);
                    }
                    .value {
                      flex: 1;
                      text-align: left;
                      margin-left: 15px;
                      color: rgba(2, 239, 5);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>